import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var SuccessFactorsSvg = function SuccessFactorsSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F9B500",
    d: "M15.843 2C13.15 2 12 3.068 11.995 3.078 11.986 3.068 10.837 2 8.148 2 5.445 2 2 3.868 2 8.511c0 4.644 6.642 10.1 7.568 11.019C10.493 20.452 12 22 12 22s1.507-1.548 2.432-2.47C15.358 18.607 22 13.155 22 8.51 21.995 3.868 18.546 2 15.843 2m-2.35 15.452c-.265.242-.458.416-.595.557-.27.27-.586.59-.903.909-.316-.32-.632-.64-.902-.909-.142-.141-.33-.315-.595-.557-4.206-3.836-6.336-6.845-6.336-8.94 0-1.475.444-2.608 1.324-3.375.7-.612 1.7-.977 2.662-.977 1.557 0 2.107.365 2.423.539.316.173 1.42 1.338 1.42 1.338s.925-1.087 1.434-1.338c.508-.247.852-.544 2.423-.544.966 0 1.96.366 2.661.977.88.768 1.324 1.905 1.324 3.375-.004 2.1-2.134 5.11-6.34 8.945"
  }));
};
export var SuccessFactors = function SuccessFactors(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: SuccessFactorsSvg
  }));
};